import { Command } from "commander";
import chalk from "chalk";
import { generateUpgradeRecommendation } from "../upgrade/upgradeEngine.js";
import type { UpgradeRecommendation } from "../models/UpgradeRecommendation.js";

const RISK_COLOR = {
  LOW: chalk.green,
  MEDIUM: chalk.yellow,
  HIGH: chalk.red,
};

export const upgradeCheckCommand = new Command("upgrade-check")
  .description("Analyze current React Native version and produce upgrade recommendations")
  .option("--json", "Output in JSON format")
  .action(async (options: { json?: boolean }) => {
    const cwd = process.cwd();
    try {
      const rec: UpgradeRecommendation = await generateUpgradeRecommendation(cwd);

      if (options.json) {
        console.log(JSON.stringify(rec, null, 2));
        process.exit(0);
        return;
      }

      console.log();
      console.log(chalk.bold.underline("Upgrade Intelligence"));
      console.log();

      console.log(chalk.bold("Current Version"));
      console.log(`  React Native:  ${chalk.cyan(rec.currentRNVersion)}`);
      if (rec.currentExpoVersion) {
        console.log(`  Expo:          ${chalk.cyan(rec.currentExpoVersion)}`);
      }
      console.log();

      console.log(chalk.bold("Recommended Version"));
      console.log(`  React Native:  ${chalk.green(rec.recommendedRNVersion)}`);
      if (rec.recommendedExpoVersion) {
        console.log(`  Expo:          ${chalk.green(rec.recommendedExpoVersion)}`);
      }
      console.log();

      const riskColor = RISK_COLOR[rec.riskLevel] ?? chalk.white;
      console.log(chalk.bold("Risk Level"));
      console.log(`  ${riskColor(rec.riskLevel)}  ${chalk.dim(rec.riskReason)}`);
      console.log();

      if (rec.affectedPackages.length > 0) {
        console.log(chalk.bold("Affected Packages"));
        for (const pkg of rec.affectedPackages) {
          const breaking = pkg.breaking ? chalk.red(" [BREAKING]") : "";
          console.log(
            `  ${chalk.yellow("⚠")} ${pkg.name}  ${chalk.dim(pkg.currentVersion)} → ${chalk.green(pkg.recommendedVersion)}${breaking}`
          );
          if (pkg.notes) console.log(`    ${chalk.dim("→")} ${chalk.dim(pkg.notes)}`);
        }
        console.log();
      }

      console.log(chalk.bold("Required Actions"));
      for (const action of rec.requiredActions) {
        console.log(`  ${chalk.dim("·")} ${action}`);
      }
      console.log();
    } catch (err: any) {
      if (options.json) {
        console.log(JSON.stringify({ success: false, error: err?.message }, null, 2));
      } else {
        console.log(chalk.red(`✖ ${err?.message || "Unknown error"}`));
      }
      process.exit(1);
    }
  });
